import { FC, MouseEventHandler, ReactNode } from "react";

import { ErrorContainer, ErrorIcon, ErrorMessage } from "./ErrorBar.Styled";

import triangleAlertSrc from "../../assets/TriangleAlert.svg";

type Props = {
    message: ReactNode | string | null;
    onClick?: MouseEventHandler<HTMLElement>;
};

const ErrorBar: FC<Props> = ({ message = "", onClick }: Props) => {
    if (message) {
        return (
            <ErrorContainer onClick={onClick}>
                <ErrorIcon src={triangleAlertSrc} alt="Triangular error icon" />
                <ErrorMessage className="text-deep-black">
                    {typeof message === "string" && message.length > 100
                        ? `${message.slice(0, 100)}…`
                        : message}
                </ErrorMessage>
            </ErrorContainer>
        );
    }

    return null;
};

export default ErrorBar;
